<template>
    <div class="border  p-4 w-100 relative">

        <!-- Selected tags from backend -->
        <div class="w-100 scrollable-tags-list">
            <div 
                class="border bg-secondary bg-gradient my-2 px-4 py-2 d-flex rounded-md align-items-center" 
                v-for="(ad_tag_id, index) in selectedTags" 
                :key="ad_tag_id"
                draggable="true"
                @dragstart="dragStart(index)"
                @dragover.prevent
                @drop="drop(index)"
                style="cursor: move;"
            >
                <i class="fas fa-grip-vertical mr-3 text-muted"></i>
                <h3 class="mb-0">{{ AdTagName(ad_tag_id) }}</h3>
                <span class="badge badge-primary ml-2">{{ index + 1 }}</span>
                <a href="#" @click.prevent="unSelectAdTag(ad_tag_id)" class="ml-auto"><i class="fas fa-times"></i></a>
            </div>
        </div>
        
        <input type="search" v-model="adtag_search" 
        placeholder="Select or add new ad tags" 
        name="desktop-mobile" 
        class="form-control dropdown-toggle" 
        data-toggle="dropdown" 
        aria-haspopup="false" 
        aria-expanded="false" >
        
        <div class="dropdown-menu w-100 scrollable-dropdown">
            <a class="dropdown-item bg-secondary bg-gradient sticky-header" href="#" @click.prevent="showAdTagModal">ADD NEW AD TAG</a>
            <!-- Select and Unselect new ad tags -->
            <div class="dropdown-item d-flex align-items-center" v-for="ad_tag in adtags" :key="ad_tag.id">
                <i class="nav-icon fas fa-pencil-alt cursor-pointer" @click.prevent="editTag(ad_tag)" ></i>
                <a class="nav-icon"  @click.prevent="selectAdTag(ad_tag.id)"  href="#">{{ad_tag.name}}</a>
            </div>
        </div>

        <ad-tag-modal :adtag="selectedTag" @updateList="loadAdTags"/>

    </div>
</template>
<script>
import AdTagModal from './AdTagModal.vue'

import { RepositoryFactory } from '@/services/repositories/PlayerAPI/RepositoryFactory'
const AdTagsRepo = RepositoryFactory.get('adtags')

export default {
    components: {
        AdTagModal,
    },
    props: {
        schedules: {
            type: Array | Object,
            required : true
        },
        schedule_type: {
            type: String,
            required : true
        },
        deleteScedule: {
            type: Boolean
        }
    },
    data: () => {
        return {
            adtags: [],
            selectedTag: {},
            selectedTags: [],
            adtag_search: '',
            website_id: 0,
            draggedIndex: null
        }
    },
    mounted() {
        this.loadAdTags()
    },
    methods: {
        selectAdTag(adtag_id) {
            // Check if already selected
            if (this.selectedTags.includes(adtag_id)) {
                return
            }

            if(this.schedule_type == 'vast') {
                this.selectedTags = [adtag_id]
                this.selectionChanged()
                return
            }

            this.selectedTags.push(adtag_id)
            this.selectionChanged()
        },
        unSelectAdTag(adtag_id) {
            if(this.schedule_type == 'vast') {
                this.selectedTags = []
                this.selectionChanged()
                return
            }

            // Use filter to remove the specific adtag_id
            this.selectedTags = this.selectedTags.filter(id => id !== adtag_id)
            this.selectionChanged()
        },
        dragStart(index) {
            this.draggedIndex = index
        },
        drop(dropIndex) {
            if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
                return
            }

            // Reorder the array
            const draggedItem = this.selectedTags[this.draggedIndex]
            const newArray = [...this.selectedTags]
            
            // Remove from old position
            newArray.splice(this.draggedIndex, 1)
            
            // Insert at new position
            newArray.splice(dropIndex, 0, draggedItem)
            
            this.selectedTags = newArray
            this.draggedIndex = null
            this.selectionChanged()
        },
        editTag(tag) {
            this.selectedTag = tag
            $(`#AdTagModal`).modal()
        },
        selectionChanged() {
            var data = { 
                'data': this.selectedTags,
                'type': this.schedule_type
            }
            this.$emit('changed', data)
        },
        showAdTagModal() {
            $(`#AdTagModal`).modal()
        },
        loadAdTags() {
            var query = {
                website: this.website_id,
                limit: 1000
            }
            AdTagsRepo.query(query).then(result => {
                this.adtags = result.data.results
            }).catch(error => {})
        },
        AdTag(adtag_id) {
            var adtag = this.adtags.filter(element => { return element.id == adtag_id })[0]
            if(adtag)
                return adtag
        },
        AdTagName(adtag_id) {
            var adtag = this.adtags.filter(element => { return element.id == adtag_id })[0]
            if(adtag)
                return adtag.name
        }
    },
    computed: {
        filteredAdTags: function() {
            return this.adtags.filter((ele) => {
                return ele.name.includes(this.adtag_search)
            })
        },
    },
    watch: {
        'schedules': {
            handler: function (schedules) {
                if(this.schedule_type == 'vast') {
                    this.selectedTags = [ schedules.id || schedules[0] || schedules ]
                    return
                }

                let list = []
                this.schedules.forEach(function(element) {
                    if(element.id) {
                        list.push(element.id)
                    } else {
                        list.push(element)
                    }
                })
                this.selectedTags = list
            },
            deep: true,
            immediate: true
        },
        'deleteScedule': {
            handler: function (clear) {
                if(clear) {
                    this.selectedTags = []
                    this.selectionChanged()
                    this.deleteScedule = false
                }
            },
            deep: true,
            immediate: true
        },
        '$route.query.website': { 
            handler: function (website) {
                if(typeof website !== 'undefined') {
                    // check if user is not loaded 
                    // website placements_groups before
                    if(this.website_id !== website) {
                        // match website with passed from query
                        this.website_id = website
                    }
                } else {
                    this.$router.push({name: "website"})
                }
            },
            deep: true,
            immediate: true
        },
    }
}
</script>
<style scoped>
.scrollable-dropdown {
    max-height: 400px;
    overflow-y: auto;
}

.sticky-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #6c757d !important;
}

.scrollable-tags-list {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: 1rem;
}

.scrollable-tags-list::-webkit-scrollbar {
    width: 8px;
}

.scrollable-tags-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.scrollable-tags-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.scrollable-tags-list::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.border.bg-secondary.bg-gradient {
    transition: all 0.2s ease;
}

.border.bg-secondary.bg-gradient:hover {
    background-color: #5a6268 !important;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.border.bg-secondary.bg-gradient[draggable="true"] {
    user-select: none;
}

.fa-grip-vertical {
    opacity: 0.5;
}

.border.bg-secondary.bg-gradient:hover .fa-grip-vertical {
    opacity: 1;
}
</style>